import { FC } from 'react'
import { WithPostUid } from 'interfaces/feed'
import { feedPostSelector } from 'selectors/feedSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import FeedPostContainer from 'components/features/socialFeed/FeedPost/FeedPostContainer'
import { InsightPost } from 'components/features/insights/InsightPost/InsightPost'

type PostTypeJunctionProps =
  & WithPostUid
  & {
    singlePostPage?: boolean
  }

export const PostTypeJunction: FC<PostTypeJunctionProps> = (props) => {
  const { postUid, singlePostPage } = props
  const post = useStoreSelector((state) => feedPostSelector(state, props))

  return (
    <>
      { post && post.type === 'post' && (<FeedPostContainer postUid={ postUid } singlePostPage={ singlePostPage } />) }
      { post && post.type === 'sponsored_post' && (<InsightPost postUid={ postUid } />) }
    </>
  )
}
